<template>
  <div style="pointer-events: none; position: absolute; overflow: hidden">
    <svg>
      <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="49.033%" id="a">
          <stop stop-color="#EE3E80" offset="0%" />
          <stop stop-color="#D91D49" offset="100%" />
        </linearGradient>
      </defs>
    </svg>
  </div>
  <div class="root">
    <div
      class="bg"
      :style="{ 'background-image': `url('${backgroundImage}')` }"
    >      
    </div>
    <div class='holder'>
      <TopBar @toggleMobile="toggleMobile" />
      <router-view class="router" :class="{ 'show-mobile': showMobile }" />
    </div>
    <BottomBar />
  </div>
</template>
<script>
import TopBar from "@/components/TopBar";
import BottomBar from "@/components/BottomBar";
export default {
  name: "TicketFinder",
  components: {
    TopBar,
    BottomBar,
  },
  data: function () {
    return {
      showMobile: false,
      backgroundImage: "",
      map: {
        "Interested In": require("@/assets/images/background-image.jpg"),
        "Games Attending": require("@/assets/images/background-image.jpg"),
        "Groups Attending": require("@/assets/images/background-image.jpg"),
        "Guests Attending": require("@/assets/images/background-image.jpg"),
        "My Options": require("@/assets/images/background-image.jpg"),
        "Ideal Benefits": require("@/assets/images/background-image.jpg"),
        Recommendation: require("@/assets/images/background-image.jpg"),
      },
    };
  },
  created() {
    this.backgroundImage =
      this.map[this.$route.name] ??
      require("@/assets/images/background-image.jpg");
  },
  methods: {
    toggleMobile(value) {
      this.showMobile = value;
    },
  },
  watch: {
    "$route.name"(to, from) {
      this.backgroundImage =
        this.map[to] ?? require("@/assets/images/main-background.jpg");
    },
  },
};
</script>
<style lang="scss">
@font-face {
  font-family: "Heading Pro";
  src: url("~@/assets/fonts/HeadingPro-Bold.woff2") format("woff2"),
    url("~@/assets/fonts/HeadingPro-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Heading Pro Book";
  src: url("~@/assets/fonts/HeadingPro-Book.woff2") format("woff2"),
    url("~@/assets/fonts/HeadingPro-Book.woff") format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "TBJ Split";
  src: url("~@/assets/fonts/TBJSplit.woff2") format("woff2"),
    url("~@/assets/fonts/TBJSplit.woff") format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
:root {
  --light-blue: #6ca9db;
  --dark-blue: #00264a;
  --logo-blue: #204178;
  --off-white: #fffffe;
  --grey: #515151;
  --logo-red: #d91d49;
}
body {
  margin: 0;
  height: 100vh;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #515151;
  height: inherit;
  overflow:auto;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--dark-blue);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--light-blue);
  }
  .holder {
    display: flex;
    flex-grow: 1;
    flex-direction: column;    
    background-size: cover;
    background-attachment: fixed;
    transition: background-image 1s ease;
    z-index: 1;
  }
  .bg {
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:calc(100% - 67px);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    background-position: center;
    background-size: cover;
  }
  .root {
    background: var(--dark-blue);
    display: flex;
    min-height: 100%;
    flex-direction: column;
    position: relative;
    .holder > * {
      flex-shrink: 0;
      transition: background-image 1s ease;
      z-index: 1;
      position: relative;
      &.router {
        flex-grow: 1;
        max-width: 1300px;
        margin-left: auto;
        margin-right: auto;
        @media (max-width: 500px) {
          transition: opacity 0.8s cubic-bezier(0.075, 0.82, 0.165, 1);
          &.show-mobile {
            opacity: 0;
            pointer-events: none;
          }
        }
      }
    }
  }
}
</style>
